import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { HamburgerIcon } from "@chakra-ui/icons";
import { Flex, Icon, Menu, MenuButton, MenuList, MenuItem, Td, Text, Tooltip, Tr, useColorModeValue } from "@chakra-ui/react";
import moment from "moment";

import { removeDocumentAsync, updateDocumentActiveAsync } from "../../redux/user/userSlice";
import { API } from "../../utils/http";
import { fullDateFormat, fullDateTimeFormat } from "../../utils/types";
import { getDocumentBadge } from "../../utils/utils";

function TruncatedText({ children, label, maxW, fontSize = "sm", fontWeight, color, ...rest }) {
	const text = children == null || children === "" ? "-" : children;
	const tooltipLabel = label ?? (text === "-" ? "" : String(text));
	return (
		<Tooltip label={tooltipLabel} isDisabled={!tooltipLabel} openDelay={400}>
			<Text fontSize={fontSize} fontWeight={fontWeight} color={color} noOfLines={1} maxW={maxW} {...rest}>
				{text}
			</Text>
		</Tooltip>
	);
}

function DocumentsTableRow(props) {
	const { row, propertyId } = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const textColor = useColorModeValue("gray.700", "white");

	const deleteDocument = (documentId) => {
		dispatch(removeDocumentAsync({ documentId, propertyId }));
	};
	const getDocument = (documentId, documentName) => {
		API.put("get-document", { documentId, propertyId, documentName }).then((response) => {
			window.open(response.data.url, "_blank");
		});
	};
	const markAsActive = (documentId) => {
		dispatch(updateDocumentActiveAsync({ documentId, propertyId, type: row.type, active: true }));
	};
	const markAsInactive = (documentId) => {
		dispatch(updateDocumentActiveAsync({ documentId, propertyId, type: row.type, active: false }));
	};

	return (
		<Tr>
			<Td pl="0px" whiteSpace="nowrap">
				<Flex direction="column" gap={1}>
					<Text fontSize="sm" color={textColor}>
						{row.addedDate ? moment(row.addedDate).format(fullDateTimeFormat) : "-"}
					</Text>
					{getDocumentBadge(row)}
				</Flex>
			</Td>
			<Td maxW={{ base: "10rem", md: "16rem" }}>
				<TruncatedText color={textColor} label={row.name}>
					{row.name || "-"}
				</TruncatedText>
			</Td>
			<Td whiteSpace="nowrap">
				<Text fontSize="sm" color={textColor}>
					{t(`types.${row.type}`) || "-"}
				</Text>
			</Td>
			<Td maxW="8rem">
				<TruncatedText color={textColor} label={row.number}>
					{row.number || "-"}
				</TruncatedText>
			</Td>
			<Td whiteSpace="nowrap">
				<Text fontSize="sm" color={textColor}>
					{row.startingDate ? moment(row.startingDate).format(fullDateFormat) : "-"}
				</Text>
			</Td>
			<Td whiteSpace="nowrap">
				<Text fontSize="sm" color={textColor}>
					{row.expirationDate ? moment(row.expirationDate).format(fullDateFormat) : "-"}
				</Text>
			</Td>
			<Td w="1%">
				<Menu closeOnSelect={false}>
					<MenuButton as="button" type="button" aria-label={t("table.actions")}>
						<Icon as={HamburgerIcon} />
					</MenuButton>
					<MenuList>
						<MenuItem isDisabled={!row.name} onClick={() => getDocument(row.id, row.name)}>
							Download
						</MenuItem>
						{row.active ? (
							<MenuItem onClick={() => markAsInactive(row.id)}>Mark as inactive</MenuItem>
						) : (
							<MenuItem onClick={() => markAsActive(row.id)}>Mark as Active</MenuItem>
						)}
						<MenuItem onClick={() => deleteDocument(row.id)}>Delete</MenuItem>
					</MenuList>
				</Menu>
			</Td>
		</Tr>
	);
}

export default DocumentsTableRow;
